import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

// 卡牌语系接口
export interface CardLanguage {
  id: number;
  name: string;
  sort: number;
  cards_count?: number;
  created_at: string;
  updated_at: string;
}

// 下拉选项接口
export interface CardLanguageOption {
  id: number;
  name: string;
}

@Module
export default class CardLanguageModule extends VuexModule {
  card_language_list = [] as Array<CardLanguage>;
  card_language_count = 0;
  card_language = {} as CardLanguage;
  all_card_languages = [] as Array<CardLanguageOption>;

  get currentCardLanguageList(): Array<CardLanguage> {
    return this.card_language_list;
  }

  get currentCardLanguage(): CardLanguage {
    return this.card_language;
  }

  get currentCardLanguageCount(): number {
    return this.card_language_count;
  }

  get currentAllCardLanguages(): Array<CardLanguageOption> {
    return this.all_card_languages;
  }

  @Mutation
  [Mutations.SET_CARD_LANGUAGE_LIST](card_language_list: Array<CardLanguage>) {
    this.card_language_list = card_language_list;
  }

  @Mutation
  [Mutations.SET_CARD_LANGUAGE](card_language: CardLanguage) {
    this.card_language = card_language;
  }

  @Mutation
  [Mutations.SET_CARD_LANGUAGE_COUNT](count: number) {
    this.card_language_count = count;
  }

  @Mutation
  [Mutations.SET_ALL_CARD_LANGUAGES](all_card_languages: Array<CardLanguageOption>) {
    this.all_card_languages = all_card_languages;
  }

  @Action
  [Actions.GET_CARD_LANGUAGE_LIST](params: Record<string, unknown>) {
    ApiService.setHeader();

    let queryString = "?";
    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
          queryString += "&" + key + "=" + params[key];
        }
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/card_languages", queryString)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_CARD_LANGUAGE_LIST, data["card_languages"] || []);
          this.context.commit(Mutations.SET_CARD_LANGUAGE_COUNT, data["total_result"] || 0);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }

  @Action
  [Actions.GET_CARD_LANGUAGE](id: number) {
    ApiService.setHeader();

    return new Promise<void>((resolve, reject) => {
      ApiService.get(`admin/card_languages/${id}`)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_CARD_LANGUAGE, data["card_language"]);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }

  @Action
  [Actions.CREATE_CARD_LANGUAGE](params: Record<string, unknown>) {
    ApiService.setHeader();

    return new Promise<{ success: boolean; error_msg?: string }>((resolve, reject) => {
      ApiService.post("admin/card_languages", { card_language: params })
        .then(({ data }) => {
          if (data.success) {
            this.context.commit(Mutations.SET_CARD_LANGUAGE, data["card_language"]);
          }
          resolve(data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject(response?.data);
        });
    });
  }

  @Action
  [Actions.UPDATE_CARD_LANGUAGE](credentials: { id: number; values: Record<string, unknown> }) {
    ApiService.setHeader();

    return new Promise<{ success: boolean; error_msg?: string }>((resolve, reject) => {
      ApiService.put(`admin/card_languages/${credentials.id}`, { card_language: credentials.values })
        .then(({ data }) => {
          if (data.success) {
            this.context.commit(Mutations.SET_CARD_LANGUAGE, data["card_language"]);
          }
          resolve(data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject(response?.data);
        });
    });
  }

  @Action
  [Actions.DELETE_CARD_LANGUAGE](id: number) {
    ApiService.setHeader();

    return new Promise<{ success: boolean; error_msg?: string }>((resolve, reject) => {
      ApiService.delete(`admin/card_languages/${id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject(response?.data);
        });
    });
  }

  @Action
  [Actions.GET_ALL_CARD_LANGUAGES]() {
    ApiService.setHeader();

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/card_languages/all")
        .then(({ data }) => {
          this.context.commit(Mutations.SET_ALL_CARD_LANGUAGES, data["card_languages"] || []);
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response?.data?.errors || '请求失败');
          reject();
        });
    });
  }
}
